<template>
  <b-row>
    <b-col>
      <h6 class="compo-heading">{{ $t('5003.manufacturing.manufacturing') }}</h6>
    </b-col>
  </b-row>
  <div class="details-card">
    <b-row>
      <b-col lg="12" md="12" sm="12" cols="12">
        <div class="field">
          <CustomDropDown v-model="Manufacturing.ManufatureId" :items="ManufactureDropdown.maufactureoption"
            @change="ManufctureOnChange" name="Manufacturer Name" id="Manufacturer Name" :rules="{ required: false }"
            :required-icon="false" :tabindex="20" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, toRefs, onMounted } from "vue";
import service from "../../Service/ItemMasService";
import CustomDropDown from "../../../../components/FormComponents/Dropdown.vue";

export default defineComponent({
  components: {
    CustomDropDown,
  },

  props: {
    value: Object,
  },

  methods: {},

  setup(props, { emit }) {
    let session: any = localStorage.getItem('UsersData')

    session = JSON.parse(session)
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let Manufacturing = reactive({
      ManufatureId: ref(),
    });
    onMounted(() => {
      LoadManufacture();
      Object.assign(Manufacturing, props.value);
      input();
    });

    function input() {
      emit("update:modelValue", Manufacturing);
    }

    //Load Manufactures
    const ManufactureDropdown = ref({
      maufactureid: null,
      maufactureoption: [],
    });

    async function LoadManufacture() {
      debugger;
      try {
        const response = await service.Manufacture();

        ManufactureDropdown.value.maufactureoption = response["result"]
          .filter((f) => f.IsActive == true && f.HospitalId == HospitalId && f.BranchId == BranchId)
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
      input();
    }

    //Manufacture On Change
    const ManufctureOnChange = (value: any, option: Selection) => {
      debugger;
      Manufacturing.ManufatureId = value.value;
    };

    return {
      ManufactureDropdown,
      Manufacturing,
      input,
      LoadManufacture,
      ManufctureOnChange,
    };
  },

  created() { },
});
</script>
